import {
  buildReviewableCandidateShell,
  buildReviewableOrigin,
  REVIEWABLE_ORIGIN_TYPES,
} from '../features/reviewableItems/reviewableItemFlow';

const normalizeText = (value = '') => String(value || '').trim();

export const TIMELINE_FACT_REVIEW_DOMAIN = 'timeline_fact';
export const TIMELINE_FACT_REVIEW_ALLOWED_ACTIONS = ['add_to_timeline', 'ignore'];

/**
 * Candidate for a bare dated fact (admission date, discharge date, ...) with
 * no narrative or behavior shape. Payload carries only date/label/sourceText
 * — nothing behavior-specific.
 */
export const buildTimelineFactReviewCandidate = ({
  origin = {},
  extractedItem = {},
  confidence = '',
  suggestedAction = 'add_to_timeline',
} = {}) => {
  const label = normalizeText(extractedItem.label);
  const date = extractedItem.date || null;
  const sourceText = normalizeText(extractedItem.sourceText || origin.sourceText || label);
  const savedOrigin = buildReviewableOrigin({
    id: origin.id,
    type: origin.type || REVIEWABLE_ORIGIN_TYPES.CARE_SOURCE,
    collection: origin.collection,
    childId: origin.childId,
    sourceText,
    sourceSaved: origin.sourceSaved !== false,
    metadata: origin.metadata || {},
  });

  return {
    ...buildReviewableCandidateShell({
      origin: savedOrigin,
      domain: TIMELINE_FACT_REVIEW_DOMAIN,
      label: label || 'Dated fact',
      sourceText,
      allowedActions: TIMELINE_FACT_REVIEW_ALLOWED_ACTIONS,
      suggestedAction,
      confidence,
      payload: { date, label, sourceText },
    }),
    extracted: { date, label, sourceText },
  };
};

export default buildTimelineFactReviewCandidate;
